/**
 * @fileoverview added by tsickle
 * Generated from: util/model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { baseObject } from './base-object';
import { transformObj } from './object-transforms';
import { capitalize, underscoreDelimit } from './string-utils';
/**
 * @record
 */
export function Model() { }
if (false) {
    /** @type {?} */
    Model.prototype.canSet;
    /** @type {?} */
    Model.prototype.captureState;
    /** @type {?} */
    Model.prototype.clone;
    /** @type {?} */
    Model.prototype.construct;
    /** @type {?} */
    Model.prototype.createCache;
    /** @type {?} */
    Model.prototype.createState;
    /** @type {?} */
    Model.prototype.getOrCache;
    /** @type {?} */
    Model.prototype.getSavedStateValue;
    /** @type {?|undefined} */
    Model.prototype.id;
    /** @type {?} */
    Model.prototype.isNew;
    /** @type {?|undefined} */
    Model.prototype.postConstruct;
    /** @type {?} */
    Model.prototype.modelName;
    /** @type {?} */
    Model.prototype.postStateChange;
    /** @type {?} */
    Model.prototype.resetState;
    /** @type {?} */
    Model.prototype.saveState;
    /** @type {?} */
    Model.prototype.update;
}
/**
 * Returns true if the `PropertyDescriptor` has a getter but no setter,
 * or if it has a value but is not writable.
 * @param {?} descriptor
 * @return {?}
 */
function isReadOnly(descriptor) {
    return (descriptor.get && !descriptor.set) || ('value' in descriptor && !descriptor.writable);
}
/** @type {?} */
export var model = baseObject.extend({
    isModel: true,
    modelName: 'unknown model',
    construct: /**
     * @param {?} data
     * @param {?=} kwargs
     * @return {?}
     */
    function (data, kwargs) {
        if (kwargs === void 0) { kwargs = {}; }
        Object.assign(this, this.DEFAULTS, data);
        this.createCache();
        if (this.postConstruct) {
            this.postConstruct(kwargs);
        }
        if (this.hasState) {
            this.createState();
            if (this.postStateChange) {
                this.postStateChange();
            }
        }
    },
    /**
     * Returns true if the specified property of the object is writable.
     */
    canSet: /**
     * Returns true if the specified property of the object is writable.
     * @param {?} property
     * @return {?}
     */
    function (property) {
        // Iterate over the prototype chain to check for property descriptors
        // eslint-disable-next-line
        for (var o = this; o !== Object.prototype; o = Object.getPrototypeOf(o)) {
            // eslint-disable-next-line
            if (o.hasOwnProperty(property)) {
                /** @type {?} */
                var descriptor = Object.getOwnPropertyDescriptor(o, property);
                if (descriptor && isReadOnly(descriptor)) {
                    return false;
                }
            }
        }
        return true;
    },
    extend: /**
     * @param {...?} args
     * @return {?}
     */
    function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        /** @type {?} */
        var obj = baseObject.extend.apply(this, args);
        // eslint-disable-next-line
        if (obj.hasOwnProperty('modelName')) {
            Object.defineProperty(obj, 'modelName', {
                configurable: false,
                enumerable: false,
                writable: false,
                value: obj.modelName
            });
        }
        return obj;
    },
    /**
     * Create a non-enumerable state property.
     */
    createState: /**
     * Create a non-enumerable state property.
     * @return {?}
     */
    function () {
        /** @type {?} */
        var state = this.captureState();
        Object.defineProperty(this, '_savedState', {
            get: (/**
             * @return {?}
             */
            function () { return state; }),
            set: (/**
             * @param {?} newState
             * @return {?}
             */
            function (newState) { return (state = newState); })
        });
    },
    saveState: /**
     * @return {?}
     */
    function () {
        this._savedState = this.captureState();
    },
    /**
     * Return a snapshot of the model's state.
     * Performs a deep copy of the enumerable properties on the model, and
     * clones any foreign models.
     */
    captureState: /**
     * Return a snapshot of the model's state.
     * Performs a deep copy of the enumerable properties on the model, and
     * clones any foreign models.
     * @return {?}
     */
    function () {
        return transformObj(this, undefined, (/**
         * @param {?} key
         * @param {?} val
         * @return {?}
         */
        function (key, val) {
            return {
                key: key,
                val: val && val.isModel ? val.clone() : val
            };
        }));
    },
    /**
     * Reset the instance to the last saved state.
     */
    resetState: /**
     * Reset the instance to the last saved state.
     * @return {?}
     */
    function () {
        Object.assign(this, this._savedState);
        this.saveState();
        this.clearCache();
        if (this.postStateChange) {
            this.postStateChange();
        }
    },
    /**
     * Return the value corresponding to key from the saved state.
     */
    getSavedStateValue: /**
     * Return the value corresponding to key from the saved state.
     * @param {?} key
     * @return {?}
     */
    function (key) {
        return this._savedState[key];
    },
    /**
     * Return a clone of the model instance.
     * This is better than calling .create() on an instance, because the
     * enumerable properties will remain enumerable on the clone.
     */
    clone: /**
     * Return a clone of the model instance.
     * This is better than calling .create() on an instance, because the
     * enumerable properties will remain enumerable on the clone.
     * @return {?}
     */
    function () {
        return this.create(this.captureState());
    },
    repr: /**
     * @return {?}
     */
    function () {
        return '';
    },
    toString: /**
     * @return {?}
     */
    function () {
        return "<" + capitalize(this.modelName) + ": " + this.repr() + ">";
    },
    /**
     * Create a cache to store complex calculated properties on.
     */
    createCache: /**
     * Create a cache to store complex calculated properties on.
     * @return {?}
     */
    function () {
        /** @type {?} */
        var cache = {};
        Object.defineProperty(this, '_cache', {
            get: (/**
             * @return {?}
             */
            function () { return cache; }),
            set: (/**
             * @param {?} newValue
             * @return {?}
             */
            function (newValue) { return (cache = newValue); })
        });
    },
    getOrCache: /**
     * @param {?} key
     * @param {?} getter
     * @return {?}
     */
    function (key, getter) {
        /** @type {?} */
        var cached = this._cache[key];
        if (!cached) {
            cached = this._cache[key] = getter.call(this);
        }
        return cached;
    },
    clearCache: /**
     * @return {?}
     */
    function () {
        var _this = this;
        Object.keys(this._cache).forEach((/**
         * @param {?} key
         * @return {?}
         */
        function (key) { return delete _this._cache[key]; }));
    },
    /**
     * Update the model with new data.
     * @param newData Object  - An object to copy the keys from
     */
    update: /**
     * Update the model with new data.
     * @param {?} newData Object  - An object to copy the keys from
     * @return {?}
     */
    function (newData) {
        Object.assign(this, newData);
        this.clearCache();
        if (this.hasState) {
            this.saveState();
        }
        return this;
    },
    /**
     * Jasmine convenience function to aid debugging.
     * @return string
     */
    jasmineToString: /**
     * Jasmine convenience function to aid debugging.
     * @return {?} string
     */
    function () {
        return this.toString();
    }
});
Object.defineProperties(model, {
    isNew: {
        get: (/**
         * @return {?}
         */
        function () {
            return !this.id;
        })
    }
});
/**
 * @record
 * @template T
 */
function GenericPropertyDescriptor() { }
if (false) {
    /**
     * @return {?}
     */
    GenericPropertyDescriptor.prototype.get = function () { };
    /**
     * @param {?} v
     * @return {?}
     */
    GenericPropertyDescriptor.prototype.set = function (v) { };
}
/**
 * Adds one or more properties to a model.
 * @template ModelType
 * @param {?} modelObj
 * @param {?} properties JavaScript object that contains one or more descriptor objects.
 *   Each descriptor object describes an accessor property.
 * @return {?}
 */
export function defineModelProperties(modelObj, properties) {
    Object.defineProperties(modelObj, properties);
}
/**
 * Given an array of expandables, which may be strings (e.g. "managedProperty")
 * or string arrays (e.g. ["managedProperty", "accessInformation"]), returns an array of underscore-delimited strings
 * (e.g. ["managed_property", "managed_property__access_information"]).
 * @param {?} expand
 * @return {?}
 */
export function expandables(expand) {
    if (!expand) {
        return [];
    }
    return expand.map((/**
     * @param {?} param
     * @return {?}
     */
    function (param) {
        return Array.isArray(param) ? expandables(flatten(param)).join('__') : underscoreDelimit(param);
    }));
}
/**
 * @param {?} arr
 * @return {?}
 */
function flatten(arr) {
    return arr.reduce((/**
     * @param {?} flat
     * @param {?} toFlatten
     * @return {?}
     */
    function (flat, toFlatten) { return flat.concat(Array.isArray(toFlatten) ? flatten(toFlatten) : toFlatten); }), []);
}
